import EventSummary from '@/components/event-summary/event-summary.view';
import { ICalendarEvent } from '@/types/calendar-event/ICalendarEvent';
import { Box, Heading } from '@chakra-ui/react';
import { t } from 'i18next';

interface IProps {
	events: Array<ICalendarEvent>;
	onEventClick: (event: ICalendarEvent) => void;
}

export default function PendingEvents(props: IProps) {
	return (
		<Box h="full" overflow="auto" minW={'sm'}>
			<Heading size="sm" p={2}>
				{t('Pending')}
			</Heading>
			<Box display="grid" gap={2} onClick={() => props.onEventClick(props.events[0])} p={2}>
				{props.events.map((e) => (
					<EventSummary key={e.id} event={e} />
				))}
			</Box>
		</Box>
	);
}
